// extracted by mini-css-extract-plugin
export default {"add-to-cart-btn":"AddToCartBtn_add-to-cart-btn__on82b","main-button":"AddToCartBtn_main-button__tcD5x","main-button-text":"AddToCartBtn_main-button-text__vEPP1"};